import { Link } from "react-router-dom";

const NotFoundPage = () => (
  <section className="not-found">
    <h2>पृष्ठ नहीं मिला</h2>
    <span className="caption">Page not found</span>
    <p>कृपया मुख्य पृष्ठ पर लौटें।</p>
    <Link to="/">
      गृह पृष्ठ
      <span className="caption">Go Home</span>
    </Link>
  </section>
);

export default NotFoundPage;
